import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { IMasterSuite } from 'src/app/models/mastersuites/mastersuite';
import { AuthService } from 'src/app/services/auth.service';
import { MastersuiteApplyComponent } from './mastersuite-apply.component';

@Component({
  selector: 'app-mastersuite-apply-menu-item',
  templateUrl: './mastersuite-apply-menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class MastersuiteApplyMenuItemComponent implements OnInit {
  @Input() selectedProducts: IProduct[] = [];
  @Input() masterSuites: IMasterSuite[] = [];
  @Output() actionComplete = new EventEmitter<void>();
  @Output() visibilityDeclared = new EventEmitter<boolean>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
  ) {}

  get canShow(): boolean {
    return this.authService.hasPermission(Permission.MasterSuitesFull);
  }

  ngOnInit(): void {
    Promise.resolve().then(() => this.visibilityDeclared.emit(this.canShow));
  }

  onApplyMastersuite(): void {
    const dialogRef = this.dialog.open(MastersuiteApplyComponent, {
      data: {
        products: this.selectedProducts,
        masterSuites: this.masterSuites,
      },
      width: '700px',
    });
    dialogRef.afterClosed().subscribe((applied: boolean) => {
      if (applied) {
        this.actionComplete.emit();
      }
    });
  }
}
